import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TabStateService {
  private readonly activeTabSubject = new BehaviorSubject<string>('settings');
  readonly activeTab$ = this.activeTabSubject.asObservable();

  private nestedActiveTab: string = '';



  getActiveTab(defaultTab: string = 'settings'): string {
    return this.activeTabSubject.value || defaultTab;
  }

  setActiveTab(tabId: string): void {
    this.activeTabSubject.next(tabId);
  }


  setActiveNestedTab(tabId: string): void {
    this.nestedActiveTab = tabId;
  }


  getActiveNestedTab(defaultTab: string = ''): string {
    return this.nestedActiveTab || defaultTab;
  }

  getNestedActiveTab(): string {
    return this.nestedActiveTab;
  }
}
